import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useAuthContext } from 'noddi-web';
import { useCustomerGroupRole } from '../../hooks/useCustomerGroupRole';

/**
 * Fleet-view teaser for organization admins. The target lives under `/home` and shows the
 * *current* user group's whole fleet, which only an admin sees; a plain member has no Fleet page,
 * and an anonymous visitor would only hit the login wall.
 */
export const FleetPromoCard = () => {
  const { isLoggedIn } = useAuthContext();
  const role = useCustomerGroupRole();

  if (!isLoggedIn || role.kind !== 'organizationAdmin') {
    return null;
  }

  return (
    <NoddiBasicCard to={customerRoutes.fleet.getPath()} className='flex flex-col gap-3'>
      <p className='text-xl font-semibold text-primary'>
        <Trans>New: Manage your fleet in one place</Trans>
      </p>
      <p>
        <Trans>
          You can now manage all your company cars, assign drivers and create bookings for your entire fleet in just a
          few clicks.
        </Trans>
      </p>
      <div className='flex justify-end'>
        <NoddiDummyButton size='small' endIcon='ArrowRight'>
          <Trans>Open fleet</Trans>
        </NoddiDummyButton>
      </div>
    </NoddiBasicCard>
  );
};
